"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_IMPORT_CTA_LINK = exports.CONTENT_IMPORT_HELP_CENTER_SLUG = exports.ContentListTabs = exports.READING_ARTICLE_NAME_MAX_CHARACTERS = exports.READING_SITE_NAME_MAX_CHARACTERS = exports.READING_URL_MAX_CHARACTERS = exports.MODULE_NAME_MAX_CHARACTERS = exports.ITEM_TYPE = exports.LIBERATION_TYPE = exports.MAX_LIBERATION_DAYS_IN_YEARS = exports.MAX_LIBERATION_DAYS = exports.MIN_LIBERATION_DAYS = exports.PAGE_TYPES = exports.FIXED_BAR_ID = void 0;
exports.FIXED_BAR_ID = 'fixed__bar__background';
exports.PAGE_TYPES = {
    ADVERTISEMENT: 'ADVERTISEMENT',
    CONTENT: 'CONTENT',
    QUIZ: 'QUIZ',
    WEBINAR: 'WEBINAR'
};
exports.MIN_LIBERATION_DAYS = 0;
exports.MAX_LIBERATION_DAYS = 7300;
exports.MAX_LIBERATION_DAYS_IN_YEARS = 20;
exports.LIBERATION_TYPE = {
    BY_DAYS: 'BY_DAYS',
    BY_DATE: 'BY_DATE'
};
exports.ITEM_TYPE = {
    MODULE: 'module',
    PAGE: 'page'
};
exports.MODULE_NAME_MAX_CHARACTERS = 100;
exports.READING_URL_MAX_CHARACTERS = 2048;
exports.READING_SITE_NAME_MAX_CHARACTERS = 200;
exports.READING_ARTICLE_NAME_MAX_CHARACTERS = 500;
exports.ContentListTabs = {
    MODULES: 0,
    EXTRA_MODULES: 1,
    TRACKS: 2
};
exports.CONTENT_IMPORT_HELP_CENTER_SLUG = 'como-importar-conteudos-entre-produtos-/22453301880461';
exports.CONTENT_IMPORT_CTA_LINK = 'https://hotmart.com';
